import { render, staticRenderFns } from "./TransMetaboProject.vue?vue&type=template&id=0e709958"
import script from "./TransMetaboProject.vue?vue&type=script&lang=js"
export * from "./TransMetaboProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports